import React from 'react'
import PropTypes from 'prop-types'
import settings from '@nobia/zeus-components/lib/settings'
import styled, { prop } from '@nobia/zeus-components/lib/styled'
import { LinkButton } from '@nobia/zeus-components/lib/buttons'
import { Container, Row, Column } from '@nobia/zeus-components/lib/grid'
import { trackEvent } from '@nobia/zeus-components/lib/analytics'
import { cdnImage } from '../../utils'

const image = cdnImage(require('../../assets/close.svg'))

const Modal = styled.div`
  position: fixed;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
`

const ModalDialog = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
`

const ModalContent = styled.div`
  position: relative;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  outline: 0;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  min-height: 100vh;
  border-radius: 0;
`

const ModalHeader = styled.div`
  display: block;
  padding: 15px;
  text-align: right;
`

const CloseButton = styled.img`
  width: 7%;
  vertical-align: middle;
  border: 0;
`

const ModalBody = styled.div`
  position: relative;
  display: block;
  padding: 15px;
`

const NewAccountButton = styled(LinkButton)`
  margin: 0;
`

const Label = styled.label`
  width: 100%;
  line-height: 10px;
`

const LoginLink = styled.a`
  text-decoration: none;
  color: ${prop('theme.colors.primary')};
  font-size: 20px;
  font-weight: bold;
`

const CustomColumn = styled(Column)`
  padding: 5px;
`

const LoginModal = ({ open, handleClose }) => {
  if (open) {
    return (
      <Modal>
        <ModalDialog>
          <ModalContent>
            <ModalHeader>
              <CloseButton src={image} onClick={handleClose} />
            </ModalHeader>
            <ModalBody>
              <Container>
                <Row>
                  <Column xs={12}>
                    <NewAccountButton
                      kind={'primary'}
                      size={'large'}
                      href={`${settings.myAccountUrl}?flow=register`}
                      onClick={() => {
                        trackEvent(
                          'MC-ESH Add to My Account',
                          'MC-ESH Click',
                          'Create New Account'
                        )
                      }}
                    >
                      Create new account
                    </NewAccountButton>
                  </Column>
                </Row>
                <Row>
                  <Column xs={12}>
                    <Label>
                      When you are logged in, all products you add here will
                      also be added to your Magnet account.
                    </Label>
                  </Column>
                </Row>
                <Row>
                  <Column xs={12}>
                    <LoginLink
                      href={settings.myAccountUrl}
                      onClick={() => {
                        trackEvent(
                          'MC-ESH Add to My Account',
                          'MC-ESH Click',
                          'Log In'
                        )
                      }}
                    >
                      Login
                    </LoginLink>
                  </Column>
                </Row>
                <Row>
                  <CustomColumn xs={12}>
                    <Label>If you already have a Magnet account</Label>
                  </CustomColumn>
                </Row>
              </Container>
            </ModalBody>
          </ModalContent>
        </ModalDialog>
      </Modal>
    )
  }
  return <div />
}

LoginModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default LoginModal
